// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MusicIconBumbleInline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 65 65"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="MusicIconBumbleInline_tsx__a">
				<stop stopColor="#71A484" offset="0%" />
				<stop stopColor="#B0B35A" offset="100%" />
			</linearGradient>
			<path
				d="M25.406 4.525a.622.622 0 0 0-.504-.142L11.238 6.52a.625.625 0 0 0-.528.617v12.245a3.467 3.467 0 0 0-.709-.445c-.923-.43-2.03-.466-3.037-.097-1.974.723-3.05 2.775-2.399 4.574.295.816.91 1.476 1.729 1.858.5.233 1.054.35 1.617.35.476 0 .959-.084 1.42-.253 1.39-.508 2.332-1.677 2.542-2.951a.618.618 0 0 0 .087-.313V11.682L24.374 9.74v7.473c-.204-.16-.427-.3-.67-.413-.923-.43-2.03-.466-3.037-.097-1.974.723-3.05 2.775-2.4 4.573.296.817.91 1.477 1.73 1.859.5.233 1.053.35 1.616.35.477 0 .96-.084 1.421-.253 1.438-.526 2.395-1.758 2.56-3.083a.614.614 0 0 0 .03-.181V5a.625.625 0 0 0-.218-.475z"
				id="MusicIconBumbleInline_tsx__b"
			/>
		</defs>
		<g fill="none" fillRule="evenodd">
			<circle fill="url(#MusicIconBumbleInline_tsx__a)" cx={32.5} cy={32.5} r={32.5} />
			<use fill="#FFF" xlinkHref="#MusicIconBumbleInline_tsx__b" transform="translate(17 18)" />
		</g>
	</svg>
);
export default MusicIconBumbleInline;
